module.exports = __webpack_public_path__ + "static/media/DK_Layout_1.983783fe.png";